import { mutations } from './mutations'

export const vuetableState = {
  state: () => ({
    planoGoverno: {
      pagina: 1,
      filtros: {
        unidade: '',
        descricao: '',
        status: ''
      }
    },
    compromissoDetails: {
      pagina: 1,
      filtros: {
        periodo: '',
        unidade_executora: '',
        descritivo: '',
        responsavel: '',
        status: ''
      }
    },
    minhasAcoes: {
      pagina: 1,
      filtros: {
        periodo: '',
        unidade_executora: '',
        descritivo: '',
        responsavel: '',
        prazo: '',
      }
    },
    materiaisPadronizados: {
      pagina: 1,
      filtros: {
        nome: '',
        descricao: '',
        medida: '',
        subgrupo: '',
        grupo: ''
      }
    },
    tags: {
      pagina: 1,
      filtros: {
        TAG_DCTAG: ''
      }
    },
    eixos: {
      pagina: 1,
      filtros: {
        EIX_DCEIXO: ''
      }
    },
    metas: {
      pagina: 1,
      filtros: {
        MET_DCTITULO: '',
        MET_DLOBJETIVO: ''
      }
    },
    dados: {
      pagina: 1,
      filtros: {
        nome: '',
        fonte: '',
        periodicidade_codigo: '*',
        secretaria_sigla: '',
        autarquia_sigla: '',
        status_values: '*'
      }
    },
    listModeration: {
      pagina: 1,
    },
    listApproved: {
      pagina: 1,
    },
    userValues: {
      pagina: 1
    },
    adminValues: {
      pagina: 1
    },
    concursosEdital: {
      pagina: 1,
      filtros: {
        numero: '',
        processo_numero: '',
        publicado: ''
      }
    },
    acompanhamentos: {
      pagina: 1,
      filtros: {
        numero: '',
        processo_numero: '',
        publicado: '',
        status: ''
      }
    },
    assistenciaPagamentos: {
      pagina: 1,
      filtros: {
        nome: '',
        ano: '',
        mes: '',
        beneficio: ''
      }
    },
    grupos: {
      pagina: 1,
      filtros: {
        nome: ''
      }
    },
    medidas: {
      pagina: 1,
      filtros: {
        nome: ''
      }
    },
    subgrupos: {
      pagina: 1,
      filtros: {
        nome: '',
        grupo_codigo: ''
      }
    },
    escalasVincularUnidadeUsuario: {
      paginaUnidadesVinculadas: 1,
      paginaUnidadesDisponiveis: 1
    },
    usuarios: {
      pagina: 1,
      filtros: {
        username: '',
        USU_DCEMAIL: '',
        USU_NMUSUARIO: ''
      }
    },
    dadosAssociados: {
      paginaAssociados: 1
    },
    dadosParaAssociar: {
      paginaParaAssociar: 1
    },
    dadosRelatoriosSecretarias: {
      paginaSecretarias: 1
    },
    dadosRelatoriosAutarquias: {
      paginaAutarquias: 1
    },
    beneficiosAssistenciais: {
      pagina: 1
    },
    emendasParlamentares: {
      pagina: 1,
      filtros: {
        ano: '',
        vereador: '',
        processos_pagamento: '',
        sigla_orgao: '',
        numero: '',
        numero_processo: '',
        descricao: '',
        resumo_utilizacao: ''
      }
    },
    vereadores: {
      pagina: 1,
      filtros: {
        nome: ''
      }
    },
    processos_pagamento: {
      pagina: 1,
      filtros: {
        numero_pagamento: '',
        valor: '',
        emenda: ''
      }
    }
  }),
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vuetableState/index.js